module.exports = __webpack_public_path__ + "img/SWP_Shield_08.a43da31b.png";